/* eslint-disable class-methods-use-this */
/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.formParent = this.closest('product-form');
      this.form = this.formParent.querySelector('form') || null;
      this.formType = this.formParent.dataset.format || null;
      this.variant_json = this.querySelector('[data-variantJSON]');
      this.metalTone = this.querySelector('[data-metaltone]');
      this.container = this.formType === 'product-card' ? this.closest('[data-product-card]') : this.closest('[data-product-container]');
    }

    connectedCallback() {
      this.updateSwatchLabel();
      if (this.formType === 'product-page') this.onVariantChange('load');

      this.addEventListener('change', (evt) => {
        const target = this.getInputForEventTarget(evt.target);
        
        // Clear validation error for the changed option
        if (target.tagName === 'SELECT') {
          const errorDiv = target.parentElement.querySelector('.validation-error');
          if (errorDiv) errorDiv.classList.add('d-none');
        } else if (target.tagName === 'INPUT') {
          const fieldset = target.closest('fieldset');
          if (fieldset) {
            const errorDiv = fieldset.querySelector('.validation-error');
            if (errorDiv) errorDiv.classList.add('d-none');
          }
          // Handle metal type and metal tone
          const container = target.closest('[data-optionindex="metalType"], [data-optionindex="metalTone"]');
          if (container) {
            const errorDiv = container.querySelector('.validation-error');
            if (errorDiv) errorDiv.classList.add('d-none');
          }
        }

        this.updateSelectedOptionLabel(target);

        eventBus.publish(PUB_SUB_EVENTS.optionChange, {
          data: {
            target,
            selectedOptionsId: this.optionValues,
          }
        });
        this.onVariantChange();
      });

      this.manageMetalSelection();
    }

    validateOptions() {
      let isValid = true;
      
      // Remove any existing validation errors
      this.querySelectorAll('.validation-error').forEach(error => error.classList.add('d-none'));

      // Check metal type if present
      const metalTypeFieldset = this.querySelector('[data-metal-swatches]');
      if (metalTypeFieldset) {
        const hasMetalTypeSelection = metalTypeFieldset.querySelector('input[type="radio"]:checked');
        const errorDiv = metalTypeFieldset.querySelector('.validation-error');
        if (!hasMetalTypeSelection) {
          isValid = false;
          if (errorDiv) {
            errorDiv.classList.remove('d-none');
          }
        } else if (errorDiv) {
          errorDiv.classList.add('d-none');
        }
      }

      // Check variant radio button groups
      this.querySelectorAll('fieldset[data-optionindex]:not([data-optionindex="ring_size"])').forEach(fieldset => {
        const hasSelection = fieldset.querySelector('input[type="radio"]:checked');
        const errorDiv = fieldset.querySelector('.validation-error');
        if (!hasSelection) {
          isValid = false;
          if (errorDiv) {
            errorDiv.classList.remove('d-none');
          }
        } else if (errorDiv) {
          errorDiv.classList.add('d-none');
        }
      });

      // Check variant select elements
      this.querySelectorAll('select.variant_selector').forEach(select => {
        const errorDiv = select.parentElement.querySelector('.validation-error');
        if (!select.value) {
          isValid = false;
          if (errorDiv) {
            errorDiv.classList.remove('d-none');
            errorDiv.scrollIntoView({ behavior: "smooth", block: "start"});
          }
        } else if (errorDiv) {
          errorDiv.classList.add('d-none');
        }
      });

      // Check closure options if present
      const closerFieldset = this.querySelector('fieldset[data-optionindex="closer"]');
      if (closerFieldset) {
        const hasCloserSelection = closerFieldset.querySelector('input[type="radio"]:checked');
        const errorDiv = closerFieldset.querySelector('.validation-error');
        if (!hasCloserSelection) {
          isValid = false;
          if (errorDiv) {
            errorDiv.classList.remove('d-none');
            errorDiv.scrollIntoView({ behavior: "smooth", block: "start"});
          }
        } else if (errorDiv) {
          errorDiv.classList.add('d-none');
        }
      }

      // Check ring size if present
      const ringSizeSelect = this.querySelector('fieldset[data-optionindex="ring_size"]');
      if (ringSizeSelect) {
        const hasSelection = ringSizeSelect.querySelector('select');
        const errorDiv = ringSizeSelect.querySelector('.validation-error');
        if (!hasSelection.value) {
          isValid = false;
          if (errorDiv) {
            errorDiv.classList.remove('d-none');
            errorDiv.scrollIntoView({ behavior: "smooth", block: "end"});
          }
        } else if (errorDiv) {
          errorDiv.classList.add('d-none');
        }
      }

      return isValid;
    }

    updateSwatchLabel(){
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          const input = swatch.querySelector('input[type="radio"]');
          const colorHandle = input.dataset.handle;
          const swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }

    /**
     * Trigger this function variant is changed
     */
    onVariantChange() {
      this.setCurrentVariant();
      eventBus.publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          container: this.container,
          variant: this.currentVariant,
        },
      });

      if (this.formType === 'product-page' && this.currentVariant) 
        globalSpace.product.currentVariant = this.currentVariant;
      if(typeof this.formParent?.updateProductDetails == 'function'){
        this.formParent.updateProductDetails(this.container, this.currentVariant);
      }
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('select.variant_selector, fieldset input[type="radio"]:checked')).map(({ value }) => value);
    }

    /**
     * change value of currentVariant when variant being changed 
     */
    setCurrentVariant() {
      this.currentVariant = false;
      const options = this.selectedOptionValues;
      const variants = this._getVariantData();
      let metalSwatchIndex = this.querySelector('[data-metal-swatches]')?.dataset?.optionindex;
      metalSwatchIndex = metalSwatchIndex - 1;
      if(metalSwatchIndex && metalSwatchIndex >= 1){
        const selectedMetal = options[metalSwatchIndex];
        options.splice(metalSwatchIndex, 1);
        options.splice(0, 0, selectedMetal);
      }

      variants.find(variant => {
        if (variant.options.every((option, i) => options[i] === option)) {
          this.currentVariant = variant;
        }
      });
    }

    /**
     * Update selected option label immediately when an option is changed
     */
    updateSelectedOptionLabel(target) {
      if (target.tagName === 'SELECT' || target.tagName === 'OPTION') {
        let selectedOption;
        if (target.tagName == 'OPTION') {
          selectedOption = target;
          if(target.closest('select').classList.contains('ring-form-select')){
            this.updateSelectedRingSize(selectedOption);
          }
        } else {
          selectedOption = target.selectedOptions[0];
          if(target.classList.contains('ring-form-select')){
            this.updateSelectedRingSize(selectedOption);
          }
        }
        if (selectedOption) {
          const label = target.closest('fieldset').querySelector('.selected-option');
          if (label) label.innerHTML = selectedOption.dataset.valueLabel;
        }
      } else if (target.tagName === 'INPUT') {
        const fieldset = target.closest('fieldset');
        if(fieldset) {
          const selectedOption = fieldset.querySelector('input[type="radio"]:checked');
          if (selectedOption) {
            let selectedValue = selectedOption.dataset.valueLabel
            const label = fieldset.querySelector('.selected-option');
            if (label) label.innerHTML = selectedValue;

            if(selectedOption.closest('[data-metal-swatches]')){
              if(selectedOption.dataset.tone?.includes('Gold')){
                this.metalTone.disabled = false;
                this.metalTone.value = selectedOption.dataset.tone;
              }else {
                this.metalTone.value = '';
                this.metalTone.disabled = true;
              }
            }
          }
        }
      }
    }

    updateSelectedRingSize(target){
      const ringSizeContent = document.querySelector('#product-ringsize-content');
      if(ringSizeContent){
        if(target.value){
          ringSizeContent.querySelector('[data-ring-size-value]').innerText = target.value;
          ringSizeContent.querySelector('[data-ring-size-diameter]').innerText = target.dataset.insideSize;
          ringSizeContent.querySelector('[data-ring-size-details]').classList.remove('d-none');
          ringSizeContent.querySelector('[data-selected-ring-size]').classList.add('d-none');
        }else{
          ringSizeContent.querySelector('[data-selected-ring-size]').classList.remove('d-none');
          ringSizeContent.querySelector('[data-ring-size-details]').classList.add('d-none');
        }
      }
    }

    /**
     * Store the all the variants json
     */
    _getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.variant_json?.textContent);
      return this.variantData;
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
    
    get optionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }

    manageMetalSelection(){
      const metalButtons = this.querySelectorAll('.metal-selection-btn');
      const swatchInputs = this.querySelectorAll('.metal-swatch [data-metaltype]');
      metalButtons.forEach(btn => {
        btn.addEventListener('click', (evt) => {
          const selectedValue = evt.currentTarget.dataset.value;

          // Remove 'active' class from the currently active button
          this.querySelector('.metal-selection-btn.active')?.classList.remove('active');
          evt.currentTarget.classList.add('active');

          if(selectedValue == 'gold'){
            // Show/hide swatch inputs based on the selected metal type
            swatchInputs.forEach(input => {
              input.classList.toggle('d-none', input.dataset.metaltype !== selectedValue);
            });
            const visibleInputs = Array.from(swatchInputs).filter(input => !input.classList.contains('d-none'));
            visibleInputs[0]?.querySelector('.swatch-label')?.click();
          }else{
            swatchInputs.forEach(input => {
              if (input.dataset.metaltype != selectedValue) {
                input.classList.add('d-none');
              }
            });
            this.querySelector(`.metal-swatch [data-metaltype="${selectedValue}"] .swatch-label`)?.click();
          }
        });
      });
    }
}
customElements.define('variant-selects', VariantSelects);